<template>
  <div style="background-color: #f5f5f5;">
    <div class="bg2">
      <van-row>
        <van-col span="6" style="text-align: right">
          <van-image
              class="aui-shop-logo"
              round error-icon="/img/nologin.png"
              :src="$getFileAccessHttpUrl(userInfo.avatar)"
              width="75px" height="75px"/>
        </van-col>
        <van-col span="18" style="text-align: left">
          <div style="width: 100%;z-index: 99999;margin-top: 44px;" v-cloak>
            <div style="margin-left: 10px" v-cloak>
              <!--                <van-button round type="primary" style="height: 30px;" v-if="goLogin">立即登录</van-button>-->
              {{ userInfo.nickname }}
              <div style="margin-top: 5px"> ID:{{ userInfo.sid }} [{{ buyFlag == 0 ? '访客' : '会员' }}]</div>
              <!--              <div>-->
              <!--                <span>当前店铺等级为初级，累计已完成{{ departData.departLevelOrdersCount }}订单</span>-->
              <!--              </div>-->
              <div v-if="departData" style="font-size: 15px;">
                <span
                    v-if="departData.departLevel===1">店铺等级为初级，累计已完成{{
                    departData.departLevelOrdersCount
                  }}订单</span>
                <span
                    v-if="departData.departLevel===2">店铺等级为中级，距离到期还剩{{
                    departData.departLevelLastDay
                  }}天</span>
                <span
                    v-if="departData.departLevel===3">店铺等级为高级，距离到期还剩{{
                    departData.departLevelLastDay
                  }}天</span>
              </div>
            </div>
          </div>
          <van-button type="primary" v-if="userInfo.nickname&&!userInfo.avatar" @click="reloadImg" size="small">重新获取头像
          </van-button>
        </van-col>
      </van-row>
    </div>
    <div>
      <!--      <van-cell-group>-->
      <!--        <van-cell icon="label-o" title="我的身份" value="访客"/>-->
      <!--      </van-cell-group>-->
      <van-cell-group style="margin-top: 10px">
        <van-cell icon="orders-o" title="我的订单" is-link @click="goMyOrder()"/>
        <van-cell icon="like-o" title="我的爱心" is-link @click="goMyLove()"/>
        <van-cell icon="coupon-o" title="店铺分享海报" is-link @click="goShopHaiBao()" v-if="buyFlag === 1"/>
      </van-cell-group>

      <van-cell-group style="margin-top: 10px" v-if="isManager>0||exitFlag!==0||exitWdFlag!==0">
        <van-cell icon="gold-coin-o" v-if="exitWdFlag!==0" title="网点收益" is-link @click="goWd()"/>
        <van-cell icon="shop-o" v-if="isManager>0" title="店铺订单" is-link @click="goManager()"/>
        <van-cell icon="gold-coin-o" v-if="isManager>0" title="店铺收益" is-link @click="goDepartBalance()"/>
        <van-cell icon="gold-coin-o" v-if="exitFlag!==0" title="推广收益" is-link @click="goTgBalance()"/>
        <!-- 收益免授权状态 -->
        <van-cell v-if="transferAuthFlag===1" icon="shield-o" title="收益提现授权" value="已开通" label="提现将自动到账零钱"/>
        <van-cell v-else icon="shield-o" title="收益提现授权" is-link @click="goTransferAuth()">
          <template #default>
            <span style="color: #ee0a24; font-weight: 600;">未开通</span>
          </template>
          <template #label>
            <span style="color: #ee0a24;">开通后提现自动到账零钱，点击开通</span>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <div v-if="departData&& departData.departLevelOrdersCount" style="color: red;text-align: center;width: 100%;margin-top: 10px">当前未兑换订单已达{{
        departData.departLevelOrdersCount
      }}单，加油!
    </div>
    <Footer :active="1" :is-login="true"></Footer>
  </div>
</template>

<script>
import {Cell, CellGroup, Field, Dialog, Button} from 'vant';
import {postAction} from '@/api/manage';
import {Toast} from 'vant';
import Footer from '@/view/index/footer'
import Vue from "vue";
import {ACCESS_TOKEN} from "@/store/mutation-types";

export default {
  components: {
    [Cell.name]: Cell, Footer,
    [Button.name]: Button,
    [Field.name]: Field,
    [Dialog.name]: Dialog,
    [Dialog.Component.name]: Dialog.Component,
    [CellGroup.name]: CellGroup
  },
  data() {
    return {
      active: 4,
      userInfo: {},
      departData: {},
      balanceLast: 0,
      buyFlag: 0,
      isManager: 0,
      exitFlag: 0,
      exitWdFlag: 0,
      transferAuthFlag: 0,
      ordersStatus: {},
      vipDuiShow: false,
      show: true,
      vipCode: ''
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    reloadImg() {
      Vue.ls.set(ACCESS_TOKEN, '')
      window.location.reload()
    },
    loadData() {
      let that = this;
      //发送 post 请求
      postAction('/web/api/user/userInfo', {}).then(function (response) {
        console.log(response.result);
        that.userInfo = response.result.data;
        that.departData = response.result.departData;
        that.isManager = response.result.isManager;
        that.buyFlag = response.result.buyFlag
      }).finally(() => {
      })
      postAction('/web/api/user/chekUserRebateFlag', {}).then(function (response) {
        console.log(response.result);
        that.exitFlag = response.result.data;
        that.exitWdFlag = response.result.exitWdFlag;
        that.transferAuthFlag = response.result.transferAuthFlag || 0;
      }).finally(() => {
      })

    },
    goShopHaiBao() {
      this.$router.push({name: 'haibaoShop'});
    },
    goDepartBalance() {
      this.$router.push({name: 'account/departBalance'});
    },
    goMyOrder() {
      this.$router.push({name: 'account/myOrder'});
    },
    goManager() {
      this.$router.push({name: 'manager/myOrder'});
    },
    goTgBalance() {
      this.$router.push({name: 'account/tgBalance'});
    },
    goWd() {
      this.$router.push({name: 'account/wdBalance'});
    },
    goMyLove() {
      this.$router.push({name: 'account/myLove'});
    },
    goTransferAuth() {
      this.$router.push({name: 'account/transferAuth'});
    },
    getSetting() {
      this.$router.push({name: 'setting'});
    },
  }
};
</script>

<style lang="less">
.user {
  &-poster {
    width: 100%;
    height: 53vw;
    display: block;
  }

  &-group {
    margin-bottom: 15px;
  }

}

.bg2 {
  background: url('/img/bg.png') no-repeat;
  height: 140px;
}

.bg {
  background: url('/img/bg.png') no-repeat;
  height: 150px;
}

.aui-shop-logo {
  z-index: 1;
  top: 35px;
}

.aui-shop-logo-txt {
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: 99999;
  top: 126px;
  color: white;
}

.wHide {
  /*display: none;*/
}

.user-links .van-info {
  right: 25px;
}

.wShow {
  display: inline-block !important;
}

.p-my-profile--banner-info .vip.health-vip {
  background: url('/img/vipbanner2.png') no-repeat;
  background-size: 100%;
  color: #e6cb87;
}

.p-my-profile--banner-info {
  margin-top: 53px;
  text-align: center;
}

.p-my-profile--banner-info .vip {
  left: .512rem;
  display: inline-flex;
  bottom: 0px;
  width: 90%;
  height: 65px;
  padding: 0 .42666667rem;
  line-height: 1.92rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: url('/img/vipbanner.png') no-repeat;
  background-size: 100%;
}

.p-my-profile--banner-info .vip.health-vip .title {
  color: #e6cb87;
}

.p-my-profile--banner-info .vip.health-vip .wand-swipe {
  color: #e6cb87;
  background: url('/img/kuozhan.png') 99% no-repeat;
  background-size: .49866667rem .912rem;
  background-position: right 5px top 18px;
  margin-left: 1px;
  font-size: 10pt;
  line-height: 50px;
}

.p-my-profile--banner-info .vip .title {
  padding-left: 24px;
  background: url('/img/viplogo.png') 0 no-repeat;
  background-position: 0px 16px;
  background-size: 1.05333333rem 1.05333333rem;
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  margin-right: 2.13333333rem;
  font-size: 13pt;
  font-weight: 400;
  line-height: 50px;
  color: #6b331a;
}

.van-icon__image {
  width: 75px;
  height: 75px;
}

.van-cell__left-icon {
  margin-top: 5px;
}

.van-cell__right-icon {
  margin-top: 5px;
}
</style>
